import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {platformList, sportList} from "../shared.service";
import { CommonService } from '../providers/common.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private commonService: CommonService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const user: any = JSON.parse(localStorage.getItem('userDetails'));
    const currentUrl = state.url;
    if (user === null || user === '' || user === undefined) {
      const data = {
        isLogin: false,
        isSkip: true,
        platformName: platformList[platformList.DraftKings],
        sportName: sportList[sportList.NFL],
        default_platform_id: platformList.DraftKings,
        default_sport_id: sportList.NFL
      };
      this.commonService.platformandsport.sport_id = sportList.NFL;
      this.commonService.platformandsport.platform_id = platformList.DraftKings;
      localStorage.setItem('userDetails', JSON.stringify(data));

      this.router.navigate(['/Board']);
      return false;
    } else if (currentUrl === '/SignIn') {
      return false;
    }
    return true;
  }

}
